import React from "react";
import BaseCard from "./BaseCard";
import InputTypesEnum from "../../../../Enums/InputTypesEnum";
import CardHeader from "./CardHeader";
import NoteCard from "./NoteCard";
import DataTable from "../../../../Elements/DataTable/DataTableFigma";
import mathHelper from '../../../../Helpers/mathHelper';
import moneyHelper from '../../../../Helpers/moneyHelper';

class MarkUpCard extends BaseCard {
  FieldsToShowInDataTableWhenOverrideFee = () => {
    //prettier-ignore
    return [
      { label: 'Tier Name', data: 'Name', type: InputTypesEnum.TextReadOnly, tableminWidth: '375px' },
      {
        label: '% Mark-up',
        data: 'MarkUpPct',
        type: InputTypesEnum.NumberWithTwoDecimalPlaces2,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      { label: 'Mark-up', data: 'MarkedUpFeePerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: 'Revenue Per Cycle',
        data: 'MarkedUpFeePerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: 'Revenue Per Year',
        data: 'MarkedUpAnnually',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: '% Mark-Up',
        data: (item) => mathHelper.SimplePercentageTextTwoDecimal(item.MarkUpPerEvalPct),
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  };

  FieldsToShowInDataTableWhenNotOverrideFee = () => {
    //prettier-ignore
    return [
      { label: 'Tier Name', data: 'Name', type: InputTypesEnum.TextReadOnly, tableminWidth: '375px' },
      {
        label: '% Mark-up',
        data: (item) => mathHelper.SimplePercentageTextTwoDecimal(item.MarkUpPct),
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        fieldType: 'Decimal',
      },
      { label: 'Mark-up', data: 'MarkedUpFeePerEval', tableminWidth: '125px', headerPosition: 'header-text-right' },
      {
        label: 'Revenue Per Cycle',
        data: 'MarkedUpFeePerCycle',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: 'Revenue Per Year',
        data: 'MarkedUpAnnually',
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
      {
        label: '% Mark-Up',
        data: (item) => mathHelper.SimplePercentageTextTwoDecimal(item.MarkUpPerEvalPct),
        type: InputTypesEnum.TextReadOnly,
        tableminWidth: '125px',
        headerPosition: 'header-text-right',
      },
    ];
  };

  FieldsToShowInFooterDataTable() {
    return [
      { label: 'TOTAL Marked-up REVENUE', tableminWidth: '625px', headerPosition: 'header-text-right' },
      { label: '', data: 'MarkedUpRevenuePerCycleTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'MarkedUpRevenueTotal', tableminWidth: '125px', headerPosition: 'header-text-right' },
      { label: '', data: 'MarkedUpRevenueTotalPct', tableminWidth: '125px', headerPosition: 'header-text-right' },
    ];
  }

  RenderDataTable() {
    if (this.props.Tier.PricingDetails.OverrideFee) {
      return (
        <DataTable
          type={{
            FieldsToShowInDataTable: this.FieldsToShowInDataTableWhenNotOverrideFee,
            NameOfTheIdField: () => 'TierId',
            FieldsToShowInListTable: [],
            MoneyFields: this.MoneyFields,
            Currency: this.Currency,
          }}
          FieldsToShowInDataTable={this.FieldsToShowInDataTableWhenNotOverrideFee()}
          thereIsNoSuchRowMessageCheck={false}
          itemList={this.props.Tier.TierList}
          renderInputFieldFunction={this.renderInputField}
          smallDataTable={true}
        />
      );
    }
    return (
      <DataTable
        type={{
          FieldsToShowInDataTable: this.FieldsToShowInDataTableWhenOverrideFee,
          NameOfTheIdField: () => 'TierId',
          FieldsToShowInListTable: [],
          MoneyFields: this.MoneyFields,
          Currency: this.Currency,
        }}
        FieldsToShowInDataTable={this.FieldsToShowInDataTableWhenOverrideFee()}
        thereIsNoSuchRowMessageCheck={false}
        itemList={this.props.Tier.TierList}
        renderInputFieldFunction={this.renderInputField}
        smallDataTable={true}
      />
    );
  }

  renderNoteCard() {
    return (
      <NoteCard
        noteActive={this.state.noteActive}
        renderInputField={this.renderInputField}
        name='MarkUpNotes'
        value={this.props.Tier.PricingDetails}
      />
    );
  }

  renderCardHeader() {
    return (
      <CardHeader
        sectionNumber={'2B'}
        HeaderText={'Mark-up'}
        changeBodyStatus={this.changeBodyStatus}
        bodyactive={this.state.bodyactive}
        disabled={!this.props.UserCanMarkup}
        subtotal={moneyHelper.toMoneyFormat(this.props.Tier.MarkedUpRevenueTotal, this.props.Tier.PricingDetails.CurrencyCode)}
        subtotalRev={this.props.Tier.MarkedUpRevenueTotalPct + ' of revenue'}
      />
    );
  }

  renderFooter() {
    return this.props.UserCanMarkup ? (
      <footer>
        <DataTable
          type={{
            FieldsToShowInDataTable: this.FieldsToShowInFooterDataTable,
            MoneyFields: this.MoneyFields,
            Currency: this.Currency,
          }}
          headeritemList={this.props.Tier}
          thereIsNoSuchRowMessageCheck={false}
          smallDataTable={true}
        />
      </footer>
    ) : null;
  }

  render() {
    return (
      <div className='card'>
        {this.renderCardHeader()}
        {this.state.bodyactive && this.props.UserCanMarkup ? (
          <div>
            {this.renderNoteCard()}
            {this.RenderDataTable()}
          </div>
        ) : null}
        {this.renderFooter()}
      </div>
    );
  }
}

export default MarkUpCard;
